import React from "react";
import LanguagesContext from "@admin/components/LanguagesContext";
import LoaderContext from "@admin/components/LoaderContext";
import GeneralInfo from "./GeneralInfo";
import OrderContext from "./OrderContext";
import Composition from "./Composition";
import AccountingAndAnaliticalDb from "./AccountingAndAnaliticalDb";
import Fiscalization from "./Fiscalization";
import Logs from "./Logs";
import ErrorsModal from "./ErrorsModal";
import Creation from "@admin/pages/OrderEditor/Creation";

export default function OrderEditor() {
    const { paymentMethods, countries, deliveryMethods, order, currencies } = window.CMS;

    if (!paymentMethods || !countries || !deliveryMethods || !currencies) {
        throw new Error(`Недостаточно данных для редактирования заказа`);
    }

    if (!order) {
        return (
            <LoaderContext>
                <>
                    <Creation currencies={currencies} />
                    <ErrorsModal />
                </>
            </LoaderContext>
        );
    }

    return (
        <LoaderContext>
            <LanguagesContext>
                <OrderContext
                    order={order}
                    paymentMethods={paymentMethods}
                    countries={countries}
                    deliveryMethods={deliveryMethods}
                >
                    <GeneralInfo />
                    <div className="row row-cols-1 row-cols-md-2 rounded border p-5 m-0 mb-5 cursor-default">
                        <AccountingAndAnaliticalDb order={order} />
                        <Fiscalization />
                    </div>
                    <Composition />
                    <Logs />
                    <div className="d-flex justify-content-end mt-10 mb-20">
                        <a className="btn btn-primary" href="/admin/orders">
                            Вернуться к списку
                        </a>
                    </div>
                    <ErrorsModal />
                </OrderContext>
            </LanguagesContext>
        </LoaderContext>
    );
}
